import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { AuthConfig, OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { AuthConfigHelper } from './auth/auth-config-helper';
import { AppConfig } from '../appconfig';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { refreshTokenRetryInterceptor } from './auth/refresh-token-retry.interceptor';

// We need a factory since localStorage is not available at AOT build time
export function storageFactory(): OAuthStorage {
  return localStorage;
}

const authConfigFactory = (appConfig: AppConfig) => {
  const s = new AuthConfigHelper(appConfig);
  return s.authConfig();
};

@NgModule({
  imports: [OAuthModule.forRoot()],
  providers: [provideHttpClient(withInterceptors([refreshTokenRetryInterceptor]))],
  exports: [OAuthModule],
  declarations: []
})
export class RouteModule {
  static forRoot(): ModuleWithProviders<RouteModule> {
    return {
      ngModule: RouteModule,
      providers: [
        { provide: AuthConfig, useFactory: authConfigFactory, deps: [AppConfig] },
        //{ provide: OAuthModuleConfig, useValue: authModuleConfig },
        { provide: OAuthStorage, useFactory: storageFactory }
      ]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: RouteModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
